/**
 * @module actions/prices
 */
import axios from 'axios'
import {
  API_URL
} from '../constants'

/**
 * @description Gets the QualityCheck settings list for a chain/shop from the API
 * @return {Promise} Axios promise
 */
export function getQualityCheckSettingsList (chainId, shopId) {
  let data = {
    ChainId: chainId,
    ShopId: shopId
  }
  let url = API_URL + '/QualityCheck/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Gets QualityCheck settings from the API
 * @return {Promise} Axios promise
 */
export function getQualityCheckSettings (id) {
  let url = API_URL + '/QualityCheck/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Gets QualityCheck settings from the API
 * @return {Promise} Axios promise
 */
export function getAgreementQualityCheckSettings (priceModelId) {
  let url = API_URL + '/QualityCheck/PriceModel/' + priceModelId
  return dispatch => {
    return axios.get(url)
  }
}
/**
 * @description Updates the QualityCheck settings through the API
 * @return {Promise} Axios promise
 */
export function updateQualityCheckSettings (data) {
  let url = API_URL + '/QualityCheck/Post/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Update order check
 * @return {Promise} Axios promise
 */
export function updateOrderCheck (data) {
  let url = API_URL + '/Order/OrderCheck/'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/qualitychecksettings.js